import { BrandMark } from '@/shared/components/brand-mark';

const FIXE_SITE_URL = 'https://fixecrm.com';

/** Rodapé de marca FixeCRM — logo do dashboard com link para o site. */
export function PublicSurveyBrandFooter() {
  return (
    <footer className="border-t border-border/60 py-6">
      <div className="container mx-auto flex max-w-3xl justify-center px-4">
        <a
          href={FIXE_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex rounded-lg outline-none transition-opacity hover:opacity-80 focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="FixeCRM"
        >
          <BrandMark iconSize={32} wordmarkSize={20} />
        </a>
      </div>
    </footer>
  );
}
